import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    contentResults: ContentModel[];
    properties?: any;
    uri?: string;
    content?: string;
    hits?: number;
    errorMessage?: string;
}

export interface ContentModel {
    title: string;
    url: string;
    // contentPath: string;
}

export interface TECContentSearchParameter extends ApiParameter {
    query?: string;
}

const url = "/api/v1/contentSearch";

export async function getContentFromApi(search: TECContentSearchParameter) {
    const response = await get<ApiResultModel>(`${url}`, search);
    return response;
}
